/* Live drift computation — runs on the client.
 * Rule: drift_min = max(0, now - planned_end) for tasks not yet "done".
 * Authoritative drift_min lives on schedule_blocks once we record actuals (Phase 3 AI).
 * Until then, this gives live, honest drift readouts on the grid + top bar.
 */
import { parseUtc, diffMin } from "@/lib/format";

export function computeBlockDrift(block, task, now = new Date()) {
  if (!block || !task) return 0;
  // Only actively-running or blocked tasks contribute to operational drift.
  // Planned tasks past their time are "stalled" — surfaced separately in future.
  if (!["in_progress", "blocked"].includes(task.status)) return 0;
  const end = parseUtc(block.end_at);
  if (!end) return 0;
  return Math.max(0, diffMin(end.toISOString(), now.toISOString()));
}

export function computeProjectDrift(blocks, taskById, now = new Date()) {
  let total = 0;
  for (const b of blocks) {
    const t = taskById[b.task_id];
    if (!t) continue;
    total += computeBlockDrift(b, t, now);
  }
  return total;
}

// Tier thresholds (per-project tunable; defaults from PRD)
export const DRIFT_TIERS = { small: 15, medium: 45, large: 60 };

export function driftTier(driftMin, thresholds = DRIFT_TIERS) {
  if (driftMin <= 0) return "none";
  if (driftMin <= thresholds.small) return "small";
  if (driftMin <= thresholds.medium) return "medium";
  return "large";
}
